import { render, staticRenderFns } from "./EtablissementDash.vue?vue&type=template&id=54acddfc&"
import script from "./EtablissementDash.vue?vue&type=script&lang=js&"
export * from "./EtablissementDash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports